import React, { useState } from "react";
import { Formik, Form, Field, ErrorMessage } from "formik";
import * as Yup from "yup";
import axios from "axios";
import Footer from "../components/Navbar/Footer";
import Logo from "../assets/images/logo-white.png";
import { API_URL } from "../components/network/Api";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

const Forgotpassword = () => {
  const [disableSendEmail, setDisableSendEmail] = useState(false)
  const handleSubmit = (values, { setSubmitting, setFieldError , resetForm }) => {
    const url = `${API_URL}/Account/ForgetPassword`;
    const headers = {
      UtcOffsetInSecond: 19800,
      AppVersion: 1
    };

    axios
      .post(url, values, { headers })
      .then(response => {
        if (response.status === 202) {
          setFieldError("email", "Email does not exist.");
        } else {
          toast.success("Reset Email has been sent.");
          resetForm(); 
        }
      })
      .catch(error => {
      })
      .finally(() => {
        setSubmitting(false);
      });
  };

  const validationSchema = Yup.object().shape({
    email: Yup.string()
      .email("Please enter a valid email address.")
      .required("Please enter your email.")
  });

  return (
    <div className="accountBox">
      <div className="accountLeft">
        <div className="logo_account mb-5">
          <img src={Logo} alt="logo" />
        </div>
      </div>
      <div className="accountRight">
        <div className="account-body mt-auto">
          <div className="logo_account d-xl-none mb-5 text-center">
            <img src={Logo} height="80" alt="logo" />
          </div>
          <h3 className="text-center mb-4">
            <strong>Forgot Password</strong>
          </h3>
          <p className="mb-4">
            Please enter your email address. You will receive a link to create
            a new password via email
          </p>
          <Formik
            initialValues={{ email: "" }}
            validationSchema={validationSchema}
            onSubmit={handleSubmit}
          >
            {({ errors, touched }) => (
              <Form>
                <div className="form-group mb-3">
                  <label className="form-label">Email</label>
                  <Field
                    type="text"
                    className={`form-control ${
                      errors.email && touched.email ? "is-invalid" : ""
                    }`}
                    placeholder="Email"
                    name="email"
                  />
                  <ErrorMessage
                    name="email"
                    component="div"
                    className="text-danger"
                  />
                </div>
                <div className="clearfix"></div>
                <div className="form-group mt-4">
                  <button
                    type="submit"
                    className="btn btn-primary w-100"
                    disabled={disableSendEmail}
                  >
                   Send Email
                  </button>
                </div>
              </Form>
            )}
          </Formik>
          <div className="mt-5 text-center">
            <a href="/">
              <i className="fa-solid fa-arrow-left-long"></i> &nbsp;Back to
              Login
            </a>
          </div>
        </div>
        <ToastContainer
        position="top-right"
        autoClose={5000}
        hideProgressBar={false}
        closeOnClick
        pauseOnHover
        draggable
        onOpen={() => {
          setDisableSendEmail(true);
          setTimeout(() => {
            setDisableSendEmail(false);
          }, 5000);
        }}
        onClose={() => { }}
       />
        <Footer />
      </div>
    </div>
  );
};

export default Forgotpassword;
